import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDocumentReport } from 'lib/api/reports';

export type Document = {
  id: string | null;
  businessIdentifier?: string | null;
  type?: string | null;
  folio?: number | null;
  advance?: number | null;
  amount?: number | null;
  amountAdvanced?: number | null;
  amountConciliated?: number | null;
  amountConciliatedByCreditNotes?: number | null;
  amountConciliatedByDiscounts?: number | null;
  amountConciliatedByFactoring?: number | null;
  amountConciliatedByFunds?: number | null;
  amountConciliatedByPassives?: number | null;
  amountConciliatedByPayIns?: number | null;
  amountNet?: number | null;
  arrearAmount?: number | null;
  arrearConciliation?: number | null;
  arrearRate?: number | null;
  business?: any;
  businessName?: string | null;
  cancelDate?: string | null;
  companyId?: number | null;
  conciliationLog?: any[];
  conciliations?: any[];
  conciliationsCreditNotes?: any[];
  conciliationsDiscounts?: any[];
  conciliationsFactoring?: any[];
  conciliationsFunds?: any[];
  conciliationsPassives?: any[];
  conciliationsPayIns?: any[];
  confirmDate?: string | null;
  createdAt?: string | null;
  documentAmountDiscounted?: number | null;
  creditRequests?: any[];
  daysToCount?: number | null;
  documentConciliation?: number | null;
  documentRemainingAmount?: number | null;
  documentRemainingAmountDebt?: number | null;
  documentRemainingAmountNet?: number | null;
  extensions?: any[];
  factoringExtensions?: any[];
  factoringQuoteId?: number | null;
  factoringQuotes?: any[];
  fatherDocumentId?: string | null;
  interestCost?: number | null;
  issuedDate?: string | null;
  issuer?: boolean | null;
  nulledAt?: string | null;
  operationDate?: string | null;
  paidAt?: string | null;
  paymentDate?: string | null;
  pendingAccountId?: string | null;
  rate?: number | null;
  costRate?: number | null;
  requestId?: number | null;
  reversedAt?: string | null;
  sgrWarrantyRequestId?: string | null;
  stakeholder?: any;
  stakeholderIdentifier?: string | null;
  stakeholderName?: string | null;
  startingPaymentDate?: string | null;
  status?: string | null;
  subType?: string | null;
  surplusId?: string | null;
  totalArrear?: number | null;
  totalRemaining?: number | null;
  totalRemainingDebt?: number | null;
  totalRemainingNet?: number | null;
  creditNoteAmount?: number | null;
  invoiceAmount?: number | null;
  fundName?: string | null;
};

export type DocumentProfileState = {
  open: boolean;
  document: Document;
  loading: boolean;
  error: string | null;
  title?: string;
};

const initialState: DocumentProfileState = {
  open: false,
  document: { id: null },
  loading: false,
  error: null,
  title: 'Detalle documento',
};

export const fetchDocumentProfile = async (dispatch: any, id: string) => {
  const response = await getDocumentReport(dispatch, id);
  return response;
};

export const loadDocumentProfile = async (dispatch: any, id: string) => {
  dispatch(setDocumentLoading(true));
  const response = await fetchDocumentProfile(dispatch, id);
  dispatch(setDocumentData(response));
  dispatch(setDocumentLoading(false));
};

const documentProfileSlice = createSlice({
  name: 'documentProfile',
  initialState,
  reducers: {
    showDocumentProfile: (
      state,
      action: PayloadAction<Document & { title?: string }>,
    ) => {
      state.open = true;
      state.document = { ...state.document, ...action.payload };
      state.title = action.payload.title || 'Detalle documento';
      state.error = null;
    },
    hideDocumentProfile: (state) => {
      state.open = false;
      state.document = { id: null };
      state.title = 'Detalle documento';
      state.error = null;
    },
    setDocumentLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setDocumentData: (state, action: PayloadAction<Document>) => {
      state.document = { ...state.document, ...action.payload };
      state.loading = false;
      state.error = null;
    },
    setDocumentError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    updateDocument: (state, action: PayloadAction<Partial<Document>>) => {
      state.document = { ...state.document, ...action.payload };
    },
  },
});

export const {
  showDocumentProfile,
  hideDocumentProfile,
  setDocumentLoading,
  setDocumentError,
  updateDocument,
  setDocumentData,
} = documentProfileSlice.actions;

export default documentProfileSlice.reducer;
